<template>
	<div>
		<div v-for="language in languages" :key="language.id">
			<slot v-if="selectedLanguage.id === language.id" :name="language.symbol.toLowerCase()"></slot>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { languages } from '../../enums/Language';

export default {
	computed:{
		...mapState({'selectedLanguage' : 'language'}),
		languages: () => languages
	},
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/shared/LanguageSwitch.vue